import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Divider, Grid, Link, Stack, Typography } from '@mui/material';
import { PATH_AUTH, PATH_PAGE } from '../../routes/paths';
import BrandLockup from '../../components/BrandLockup';

// ----------------------------------------------------------------------

const COLUMNS: { heading: string; links: { label: string; href: string }[] }[] = [
  {
    heading: 'For job seekers',
    links: [
      { label: 'Browse jobs', href: PATH_PAGE.jobs },
      { label: 'Win a job', href: PATH_PAGE.contest },
      { label: 'Create an account', href: PATH_AUTH.signup },
    ],
  },
  {
    heading: 'For employers',
    links: [
      { label: 'Post a job', href: `${PATH_AUTH.signup}?role=employer` },
      { label: 'Sign in', href: PATH_AUTH.login },
      { label: 'Contest plans', href: PATH_PAGE.pricing },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About us', href: PATH_PAGE.about },
      { label: 'Contact us', href: PATH_PAGE.contact },
      { label: 'FAQs', href: PATH_PAGE.faqs },
    ],
  },
  {
    heading: 'Policies',
    links: [
      { label: 'Terms of Service', href: PATH_PAGE.termsOfService },
      { label: 'Refund Policy', href: PATH_PAGE.refundPolicy },
    ],
  },
];

const ADDRESS = 'Plot No. 131, Kh No. 14/1, Gali No. 4C, Goyla Vihar, New Delhi - 110071';

// ----------------------------------------------------------------------

export default function MainFooter() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#202430',
        color: '#fff',
        '& .MuiTypography-root, & a': { color: '#AEB5C5' },
        '& h6': { color: '#fff' },
        borderTop: '1px solid',
        borderColor: 'divider',
        mt: 'auto',
        pt: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 3, md: 4 }}>
          <Grid item xs={12} md={4}>
            <Stack spacing={2}>
              <Box component={RouterLink} to={PATH_PAGE.root} aria-label="Job Victory home" sx={{ textDecoration: 'none', alignSelf: 'flex-start' }}><BrandLockup light /></Box>
              <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 320 }}>
                A little ambition. A world of opportunity. Your next chapter starts here.
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 320 }}>
                {ADDRESS}
              </Typography>
              <Stack spacing={0.5}>
                {['info@jobvictory.com', 'support@jobvictory.com'].map((email) => (
                  <Link
                    key={email}
                    href={`mailto:${email}`}
                    variant="body2"
                    underline="hover"
                    sx={{ color: 'text.secondary' }}
                  >
                    {email}
                  </Link>
                ))}
              </Stack>
            </Stack>
          </Grid>

          {COLUMNS.map((column) => (
            <Grid item xs={6} sm={3} md={2} key={column.heading}>
              <Typography variant="subtitle2" sx={{ mb: 2 }}>
                {column.heading}
              </Typography>
              <Stack spacing={1.25}>
                {column.links.map((link) => (
                  <Link
                    key={`${column.heading}-${link.label}`}
                    component={RouterLink}
                    to={link.href}
                    variant="body2"
                    underline="hover"
                    sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
                  >
                    {link.label}
                  </Link>
                ))}
              </Stack>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: { xs: 3, md: 4 }, borderColor: '#FFFFFF25' }} />

        <Typography variant="body2" sx={{ color: 'text.disabled', pb: 3, textAlign: { xs: 'center', sm: 'left' } }}>
          © {new Date().getFullYear()} Job Victory. All rights reserved. Made for your next move.
        </Typography>
      </Container>
    </Box>
  );
}
